import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { inject, observer } from 'mobx-react'
import TextInput from '../../form-inputs/TextInput'
import Calendly from './Calendly'
import Hubspot from './Hubspot'
import { Button as ChaliceButton } from '../../theme/button/Button'
import styles from '../Marketplace.module.scss'

@inject('store')
@observer
class PopupEnrollRequest extends React.Component {
  handleEnrollSubRequest(event) {
    const { store, product_id, company_id, enrollment_type } = this.props
    event.preventDefault()
    const valid = store.formInputs.validate()
    if (valid) {
      const params = store.formInputs.getParams()
      params['product_id'] = product_id
      params['enrollment_type'] =
        enrollment_type !== '' ? enrollment_type : 'none'
      params['company_id'] = company_id
      store.enrollSubRequest(params, 'loading', product)
    }
    event.preventDefault()
  }

  handleChange(inputName, inputValue, event) {
    const { store } = this.props
    inputValue = inputValue.replace(/^ +/gm, '')
    store.formInputs.update(inputName, inputValue)
    event.preventDefault()
  }

  render() {
    const { store, product } = this.props
    const company = product.partner
    const msg = `
      Please provide the following information to connect with ${company.name}.
    `
    let pageContent = ''
    let lead_route_form = ''
    if (product.lead_route === 'trinet') {
      lead_route_form = (
        <div>
          <div className="row">
            <TextInput
              field={store.formInputs.street_address1}
              handleChange={(e) =>
                this.handleChange(
                  store.formInputs.street_address1.name,
                  e.target.value,
                  e
                )
              }
              icon={''}
              cols={6}
              className={classNames('form-group', styles['mb-sm'])}
            />
            <TextInput
              field={store.formInputs.street_address2}
              handleChange={(e) =>
                this.handleChange(
                  store.formInputs.street_address2.name,
                  e.target.value,
                  e
                )
              }
              icon={''}
              cols={6}
              className={classNames('form-group', styles['mb-sm'])}
            />
          </div>
          <div className="row">
            <div className="clearfix"></div>
            <TextInput
              field={store.formInputs.city}
              handleChange={(e) =>
                this.handleChange(store.formInputs.city.name, e.target.value, e)
              }
              icon={''}
              cols={6}
              className={classNames('form-group', styles['mb-sm'])}
            />
            <TextInput
              field={store.formInputs.state}
              handleChange={(e) =>
                this.handleChange(
                  store.formInputs.state.name,
                  e.target.value,
                  e
                )
              }
              icon={''}
              cols={6}
              className={classNames('form-group', styles['mb-sm'])}
            />
          </div>
          <div className="row">
            <TextInput
              field={store.formInputs.zip}
              handleChange={(e) =>
                this.handleChange(store.formInputs.zip.name, e.target.value, e)
              }
              icon={''}
              cols={6}
              className={classNames('form-group', styles['mb-sm'])}
            />
            <TextInput
              field={store.formInputs.industry}
              handleChange={(e) =>
                this.handleChange(
                  store.formInputs.industry.name,
                  e.target.value,
                  e
                )
              }
              icon={''}
              cols={6}
              className={classNames('form-group', styles['mb-sm'])}
            />
          </div>
          <div className="row">
            <TextInput
              field={store.formInputs.job_title}
              handleChange={(e) =>
                this.handleChange(
                  store.formInputs.job_title.name,
                  e.target.value,
                  e
                )
              }
              icon={''}
              cols={6}
              className={classNames('form-group', styles['mb-sm'])}
            />
            <TextInput
              field={store.formInputs.number_of_employees}
              handleChange={(e) =>
                this.handleChange(
                  store.formInputs.number_of_employees.name,
                  e.target.value,
                  e
                )
              }
              icon={''}
              cols={6}
              className={classNames('form-group', styles['mb-sm'])}
            />
          </div>
          <div className="row">
            <TextInput
              field={store.formInputs.firm_name}
              handleChange={(e) =>
                this.handleChange(
                  store.formInputs.firm_name.name,
                  e.target.value,
                  e
                )
              }
              icon={''}
              cols={12}
              className={classNames('form-group', styles['mb-sm'])}
            />
          </div>
        </div>
      )
    }
    let link = null
    const { calendly_link } = product.enterprise_overrides
    if (this.props.store.isEnterprise()) {
      link = calendly_link !== null ? calendly_link : this.props.link
    } else {
      link = this.props.link
    }
    let title = `Connect with ${company.name}`
    // Hacky....
    // make a calendar object to handle various types of embeddable calendars
    if (link && link.match(/calendly.com/)) {
      const { product_id, company_id, enrollment_type } = this.props
      const { product_name } = this.props.product
      title = 'Schedule Consultation'
      pageContent = (
        <Calendly
          productDetails={{
            product_id,
            company_id,
            enrollment_type,
            product_name
          }}
          calendlyLink={link}
          reengage={false}
        />
      )
    } else if (link && link.match(/hubspot.com/)) {
      const { product_id, company_id, enrollment_type } = this.props
      const { product_name } = this.props.product
      title = 'Schedule Consultation'
      pageContent = (
        <Hubspot
          productDetails={{
            product_id,
            company_id,
            enrollment_type,
            product_name
          }}
          hubspotLink={link}
          reengage={false}
        />
      )
    } else {
      pageContent = (
        <React.Fragment>
          <div>{msg}</div>
          <hr />
          <form onSubmit={(e) => this.handleEnrollSubRequest(e)}>
            <div className="row">
              <TextInput
                field={store.formInputs.first_name}
                handleChange={(e) =>
                  this.handleChange(
                    store.formInputs.first_name.name,
                    e.target.value,
                    e
                  )
                }
                icon={''}
                autoFocus={true}
                cols={6}
                className={classNames('form-group', styles['mb-sm'])}
              />
              <TextInput
                field={store.formInputs.last_name}
                handleChange={(e) =>
                  this.handleChange(
                    store.formInputs.last_name.name,
                    e.target.value,
                    e
                  )
                }
                icon={''}
                autoFocus={true}
                cols={6}
                className={classNames('form-group', styles['mb-sm'])}
              />
            </div>
            <div className="row">
              <TextInput
                field={store.formInputs.email}
                handleChange={(e) =>
                  this.handleChange(
                    store.formInputs.email.name,
                    e.target.value,
                    e
                  )
                }
                icon={''}
                autoFocus={true}
                cols={6}
                className={classNames('form-group', styles['mb-sm'])}
              />
              <TextInput
                field={store.formInputs.phone}
                handleChange={(e) =>
                  this.handleChange(
                    store.formInputs.phone.name,
                    e.target.value,
                    e
                  )
                }
                icon={''}
                autoFocus={true}
                cols={6}
                className={classNames('form-group', styles['mb-sm'])}
              />
            </div>
            {lead_route_form}
            <div className="clearfix"></div>
            <div className="text-center">
              <ChaliceButton type="submit">Request Consultation</ChaliceButton>
            </div>
          </form>
        </React.Fragment>
      )
    }
    return (
      <div className={styles.consultation_content}>
        <div className={styles.consultation_header}>
          <h3 className={styles.consultation_title}>{title}</h3>
          <button onClick={(e) => this.props.onClick(e)} className="close">
            &times;
          </button>
        </div>
        <div className="modal-body">{pageContent}</div>
      </div>
    )
  }
}

PopupEnrollRequest.propTypes = {
  store: PropTypes.object,
  sub_type: PropTypes.node,
  product_id: PropTypes.node,
  company_id: PropTypes.node,
  enrollment_type: PropTypes.node,
  onClick: PropTypes.func,
  product: PropTypes.object,
  email: PropTypes.string,
  link: PropTypes.string
}

export default PopupEnrollRequest
